// extracted by mini-css-extract-plugin
export default {"title":"Xba-z","warning":"Yba-z","sizeOptionsLegendText":"Zba-z"};